import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Box, Button, Stack, Typography } from '@mui/joy';
import GCoinAvatar from '../../components/gcoin/GCoinAvatar';
import { AppContext } from '../../context';
import useGCoinRead from '../../hooks/useGCoinRead';
import { cardSx, GCoinShell, LoadState } from '../../components/gcoin/GCoinUI';
import { GCoinAchievements, GCoinPositions, GCoinWins } from '../../components/gcoin/GCoinProfileContent';

export default function GCoinProfilePage() {
    const { account } = useContext(AppContext);
    const { accountId } = useParams();
    const id = accountId === 'me' ? account.id : accountId;
    const validId = /^\d+$/.test(String(id));
    const resource = useGCoinRead(validId ? `profiles/${id}/` : null);
    const navigate = useNavigate();
    const data = resource.data;
    const own = String(account.id) === String(id);
    return <GCoinShell title={own ? 'Мой профиль' : 'Профиль сотрудника'} subtitle="Результаты, места и история побед G coin" loading={resource.loading} onRefresh={resource.refresh}>
        <LoadState error={!validId ? 'Некорректный адрес профиля.' : resource.error} loading={resource.loading} empty={!data} />
        {data && <>
            <Box sx={cardSx}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <GCoinAvatar name={data.name} src={data.avatar_url} size={64} />
                    <Box sx={{ minWidth: 0 }}><Typography sx={{ fontWeight: 800, fontSize: 22, overflowWrap: 'anywhere' }}>{data.name}</Typography><Typography level="body-sm">{{ photographer:'Фотограф 📸', admin:'Администратор 🖥️', admin_photographer:'Фотограф 📸 и администратор 🖥️' }[data.role]}</Typography></Box>
                </Stack>
                <GCoinAchievements data={data} />
                {own && <Stack direction={{ xs:'column', sm:'row' }} spacing={1} sx={{ mt: 2 }}><Button onClick={() => navigate('/my-gcoin')}>Баланс и операции</Button></Stack>}
            </Box>
            <GCoinPositions data={data} />
            <GCoinWins data={data} />
        </>}
        <Button variant="plain" onClick={() => navigate('/gcoin/rating')}>Открыть общий рейтинг</Button>
    </GCoinShell>;
}